import React from 'react';
import { Shield, Lock, Eye, Database } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const Privacy = () => {
  return (
    <div className="dark-container min-h-screen pt-28 pb-20">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <div className="w-20 h-20 mx-auto mb-6 bg-brand-primary/10 border border-brand-primary rounded-sm flex items-center justify-center">
            <Lock className="text-brand-primary" size={36} />
          </div>
          <h1 className="display-large mb-4" style={{ color: 'var(--text-primary)' }}>Privacy Policy</h1>
          <p className="body-medium" style={{ color: 'var(--text-muted)' }}>Last Updated: December 2025</p>
        </div>

        <Card className="bg-white/5 border border-white/25 backdrop-blur-xl mb-8">
          <CardContent className="p-8">
            <h2 className="heading-1 mb-4" style={{ color: 'var(--text-primary)' }}>1. Information We Collect</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              We collect information necessary to provide our services and comply with regulatory requirements:
            </p>
            <ul className="space-y-2 mb-6" style={{ color: 'var(--text-secondary)' }}>
              <li>• <strong>Personal Information:</strong> Name, email, phone number, date of birth</li>
              <li>• <strong>KYC Data:</strong> Government ID, proof of address, facial verification</li>
              <li>• <strong>Wallet Information:</strong> Public wallet addresses (not private keys)</li>
              <li>• <strong>Transaction Data:</strong> Investment history, referral activity</li>
              <li>• <strong>Technical Data:</strong> IP address, browser type, device information</li>
            </ul>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>2. How We Use Your Information</h2>
            <ul className="space-y-2 mb-6" style={{ color: 'var(--text-secondary)' }}>
              <li>• Verify your identity and comply with KYC/AML regulations</li>
              <li>• Process your token investments and transactions</li>
              <li>• Calculate and distribute referral commissions</li>
              <li>• Communicate important updates and opportunities</li>
              <li>• Improve platform security and prevent fraud</li>
              <li>• Analyze platform usage and optimize user experience</li>
            </ul>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>3. Data Security</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              We implement industry-standard security measures including:
            </p>
            <ul className="space-y-2 mb-6" style={{ color: 'var(--text-secondary)' }}>
              <li>• AES-256 encryption for data at rest</li>
              <li>• TLS 1.3 encryption for data in transit</li>
              <li>• Multi-factor authentication (MFA) for accounts</li>
              <li>• Regular security audits and penetration testing</li>
              <li>• Secure cloud infrastructure with redundancy</li>
            </ul>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>4. Information Sharing</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              We do not sell your personal information. We may share data with:
            </p>
            <ul className="space-y-2 mb-6" style={{ color: 'var(--text-secondary)' }}>
              <li>• <strong>Service Providers:</strong> KYC verification partners, payment processors</li>
              <li>• <strong>Legal Authorities:</strong> When required by law or court order</li>
              <li>• <strong>Project Teams:</strong> Aggregated, anonymized investment statistics</li>
            </ul>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>5. Your Rights</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>You have the right to:</p>
            <ul className="space-y-2 mb-6" style={{ color: 'var(--text-secondary)' }}>
              <li>• Access your personal data</li>
              <li>• Request correction of inaccurate information</li>
              <li>• Request deletion (subject to legal requirements)</li>
              <li>• Export your data in machine-readable format</li>
              <li>• Opt-out of marketing communications</li>
            </ul>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>6. Cookies and Tracking</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              We use cookies for authentication, analytics, and user experience. You can control cookie preferences in your browser settings.
            </p>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>7. Data Retention</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              We retain your data for 7 years after account closure to comply with financial regulations and legal requirements.
            </p>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>8. Contact Us</h2>
            <p style={{ color: 'var(--text-secondary)' }}>
              For privacy-related inquiries, contact us at: <span className="text-brand-primary">privacy@matrixlaunch.com</span>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Privacy;
